'use client';

import { c as _c } from "react/compiler-runtime";
import styles from '@/app/cc/_component/ui/layout/Layout.module.scss';
import { useKind } from '@/app/cc/KindContext';
import BackButton from '@/components/BackButton/BackButton';
export default function HeaderBackButton() {
  const $ = _c(2);
  const kind = useKind();
  let t0;
  if ($[0] !== kind) {
    t0 = kind === "LEE_APP" ? <div className={styles.backButtonWrapper}><BackButton type="icon" /></div> : null;
    $[0] = kind;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}